import '@babel/polyfill';
import Vue from 'vue';
import store from './store';
import axios from "./modules/axios";
import "@/assets/scss/index.scss";

import vAddToCart from './components/add-to-cart.vue';
import vCart from './components/cart.vue';
import vDrawer from './components/drawer/index.vue';
import vFilter from './components/filter.vue';
import vSort from './components/sort.vue';
import vSearch from './components/search.vue';

Vue.prototype.$http = axios;

const instances = [vDrawer, vAddToCart, vCart, vFilter, vSort, vSearch];

instances.forEach(instance => {
  const elements = Array.prototype.slice.call(document.querySelectorAll(instance.selector));

  elements.forEach(el => new Vue({
    ...instance,
    el,
    // takes data attributes (data-*) on the root element and parses them as props
    propsData: Object.entries(el.dataset).reduce((sum, [key, val]) => ({
      ...sum,
      get [key]() {
       try {
         return JSON.parse(val);
       } catch(err) {
         return val;
       }
      }
    }), {})
  }));
});

if (window.Shopify.designMode) {
  document.addEventListener("shopify:section:load", ({ target }) => {
    // remove .reveal from all children
    const revealChildren = Array.prototype.slice.call(
      target.querySelectorAll(".reveal")
    );
    revealChildren.forEach((child) => child.classList.remove("reveal"));

    instances.forEach((instance) => {
      const elements = Array.prototype.slice.call(
        target.querySelectorAll(instance.selector)
      );

      elements.forEach(
        (el) =>
          new Vue({
            ...instance,
            el,
            // takes data attributes (data-*) on the root element and parses them as props
            propsData: Object.entries(el.dataset).reduce(
              (sum, [key, val]) => ({
                ...sum,
                get [key] () {
                  try {
                    return JSON.parse(val);
                  } catch (err) {
                    return val;
                  }
                },
              }),
              {}
            ),
          })
      );
    });
  });
}